export const BscVaultConfig = {
  vesting: [
    {
      contractAddress: "0xa2FC194C9f8806501cab9d07Ed03d2FaFF16a618",
      reserves: [
        "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
        "0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56",
        "0xA325Ad6D9c92B55A3Fc5aD7e412B1518F96441C0",
      ],
    },
  ],
  staked: [
    "0x3016f843ACc10d211479675c95E9895A82f94C54",
    "0xc9cb94Bc50795E2276f479Cc744047C49852A60a",
    "0x59CbE5838Ccb1279f7F6D2f700f0fE71dEa08d5A",
    "0x17b173D4B80B0B5BB7E0f1E99F5962f2D51799Eb",
    "0x3de6AFf37A4Cc25275e9d2cF9B2eE2C466E53680",
    "0x2686ceE3789c18984af065743f0bF94173Da851f",
    "0x8909106C2fB2e2AE048757FF567ac2C88e6348f9",
    "0x34697e4B5b4929d051CC68A32eA19Cc374016a77",
    "0xF04feE30118fdb83c0957C4f6AbdfDde977b9Aeb",
    "0xC5f0137ce42437d8f5eF25DA110F7FD7386178ec",
    "0xfAA05246A05C8c9c489f41A411e5e5be185C1820",
    "0xb263c56BfF03Fb71C295d73B306357AFE7e88FDb",
    "0x3CAea8d85DdC1f17d04B778774eFc255Fb3EcF60",
    "0xB88638B91E0D678bce85118fdc81E9D17C90b9de",
    "0xBFcDB6982a20DeAb7204822E5F4EfED0f4b86632",
    "0x5e20fc4B32d86dFE3161C4e67d676bbC78F69077",
  ],
};

export const EthVaultConfig = {
  vesting: [],
  staked: ["0x84D92a3D61Ec158dCf878ff24EbDcf6b2b5ec1Fa", "0xBF576c63C30E1eBb637138EE1c67A570Ff70223D"],
};

export const FtmVaultConfig = {
  vesting: [
    {
      contractAddress: "0xf3aE6b96299b46Bdeb59FBD4E43A9095459B4b87",
      reserves: ["0x0391bE54E72F7e001f6BBc331777710b4f2999Ef", "0x170772A06aFfC0d375cE90Ef59C8eC04c7ebF5D2"],
    },
  ],
  staked: [
    "0x9709730Aad5878040F382968DCb9E66F2f0a964F",
    "0x182D67287fda8A7248851AC657e74D5A048310Ae",
    "0xE7c81531Db9b13046358e53cCa7E16bac80DDd88",
  ],
};
